import { render } from "./DSSAddProject.vue?vue&type=template&id=dd94ec5c"
import script from "./DSSAddProject.vue?vue&type=script&lang=js"
export * from "./DSSAddProject.vue?vue&type=script&lang=js"

import "./DSSAddProject.vue?vue&type=style&index=0&id=dd94ec5c&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__